var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-input',{attrs:{"type":"number"},on:{"change":function($event){_vm.addResultTeamPlacePts({
                        match_id:Number.parseInt(_vm.$props.match_id),
                        place_pts:Number.parseInt(_vm.placePts)
                      })}},model:{value:(_vm.placePts),callback:function ($$v) {_vm.placePts=$$v},expression:"placePts"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }